import { useEffect, useRef, useState } from "react";
import { HeaderRecipe } from "./HeaderRecipe/HeaderRecipe";
import { BodyRecipe } from "./BodyRecipe/BodyRecipe";
import { EquipmentType, RecipeType, StepZutatList } from "@/types/baseTypes";
import styles from "./CookingMode.module.scss";
import {
  OptionsRecipeType,
  OptionsTopfiGraphicsType,
} from "@/types/OptionType";
interface CookingModeProps {
  recipeDetails: RecipeType;
  ingredientsList: StepZutatList;
  portionSize: number;
  cookingOptions: OptionsRecipeType["cooking_mode"];
  topfiGraphics: OptionsTopfiGraphicsType;
  equipmentList: EquipmentType[];
}

export const CookingMode = ({
  recipeDetails,
  ingredientsList,
  portionSize,
  cookingOptions,
  topfiGraphics,
  equipmentList,
}: CookingModeProps) => {
  // const [currentStep, setCurrentStep] = useState(0);
  const [currentStep, setCurrentStep] = useState(-3); //TODO ACTIVATEE
  const stepText = useRef<HTMLDivElement | null>(null);
  const [hasUserConsent] = useState(false);
  const [killSpeechRecognition, setKillSpeechRecognition] = useState(false);
  const [shouldMuteAudio, setShouldMuteAudio] = useState(true);
  const [servingsCount, setServingsCount] = useState(portionSize || 4);
  const headerRef = useRef<HTMLDivElement | null>(null);
  const [headerHeight, setHeaderHeight] = useState(0);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const setUseAudio = (val: any) => {
    // console.log("Setting Mute", !val);
    setShouldMuteAudio(!val);
  };
  useEffect(() => {
    if (headerRef.current) {
      const resizeObserver = new ResizeObserver(() => {
        setHeaderHeight(headerRef.current?.offsetHeight || 0);
      });
      resizeObserver.observe(headerRef.current);
      return () => resizeObserver.disconnect();
    }
  }, []);

  return (
    <article className={`${styles["cook-mode"]}`}>
      <div ref={headerRef}>
        <HeaderRecipe
          recipeDetails={recipeDetails}
          steps={recipeDetails.steps_portion_big}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          shouldMuteAudio={shouldMuteAudio}
          setAudioMute={setShouldMuteAudio}
        />
      </div>
      <div id="maincontent" />
      <BodyRecipe
        recipeDetails={recipeDetails}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        setServingsCount={setServingsCount}
        servingsCount={servingsCount}
        hasUserConsent={hasUserConsent}
        ingredients={ingredientsList.zutaten_portion_big}
        stepText={stepText}
        cookingOptions={cookingOptions}
        killSpeechRecognition={killSpeechRecognition}
        setKillSpeechRecognition={setKillSpeechRecognition}
        shouldMuteAudio={shouldMuteAudio}
        setShouldMuteAudio={setUseAudio}
        topfiGraphics={topfiGraphics}
        equipmentList={equipmentList}
        headerHeight={headerHeight}
      />
    </article>
  );
};
export default CookingMode;
